import { Component } from 'react'
import { FaFileMedical, FaFileMedicalAlt } from 'react-icons/fa'
import { FaHospitalUser, FaRegCircleQuestion } from 'react-icons/fa6'
import { RiHealthBookLine } from 'react-icons/ri'
import { BsFiletypeJson } from 'react-icons/bs'
import './menuCard.css'

class MenuCard extends Component {
    getIcon(icon) {
        switch(icon) {
            case 'clinical':
                return <FaHospitalUser />
            case 'datasharing':
                return <FaFileMedical />
            case 'iop':
                return <FaFileMedicalAlt />
            case 'emr':
                return <RiHealthBookLine />
            case 'pd':
                return <BsFiletypeJson />
            default:
                return <FaRegCircleQuestion />
        }
    }

    onSelect() {
        this.props.onSelected(this.props.idx)
    }

    render() {
        return <div className={`MenuCard-Container MenuCard-${this.props.menu.css}`} onClick={() => this.onSelect()}>
            <div className='MenuCard-Title'>{this.props.menu.label}</div>
            <div className='MenuCard-Icon'>{this.getIcon(this.props.menu.route)}</div>
        </div>
    }
}

export default MenuCard